import { useSnapshot } from "valtio"
import { AgmodalStore, configStore } from "../state/CommonState"
import { cartingStore } from "../cartingorder/cartingStore"

export default function BookingConfirmation(props) {
    useSnapshot(configStore)
    useSnapshot(cartingStore)
    let modalClass = 'modal'
    if (configStore.bookingModalVisible) modalClass += ' is-active'
    const ListAjvErrors = () => {
        if (configStore.ajvErrors && configStore.ajvErrors.length > 0) {
            return (
                <section className="modal-card-foot">
                    <ol>
                        {configStore.ajvErrors.map(e => <li>{e}</li>)}
                    </ol>
                </section>
            )
        }
        return <></>
    }
    let href=`mailto:support@${process.env.REACT_APP_ENTERPRISE_DOMAIN}?subject=Booking#%20${configStore.bookingModalNum}`
    return (
        <div className={modalClass}>
            <div className="modal-background"></div>
            <div className="modal-card">
                <section className="modal-card-head" style={{textAlign: 'left', fontSize: '1.4rem', fontWeight: 'bold'}}>
                    <span style={{width:'90%'}}>Booking Confirmation</span>
                    <button className="delete" style={{ float: 'right' }}
                        onClick={() => {
                            configStore.bookingModalVisible = false
                            AgmodalStore.pageVisible = false
                            if((cartingStore.current._id!=undefined && cartingStore.current._id.length>0) || props.createbooking){
                                AgmodalStore.apiCall = true;
                            }
                        }}>
                        </button>
                </section>
                
                <section className="modal-card-body" style={{ textAlign: 'center', fontSize: '1.3rem' }}>
                    <div>Booking Submitted Successfully</div>
                    <div>Thank you!</div>
                    <div>Your booking reference number : <strong>{configStore.bookingModalNum}</strong></div>
                    <div>Thank you for the information provided. Your Booking is Confirmed, and our team will get back to you along-with further information.</div>
                    <div>If you need immediate assistance, please reach out to us on +91 97318 15003 
                        or write us at&nbsp;
                        <a href={href}>support@{process.env.REACT_APP_ENTERPRISE_DOMAIN}</a></div>
                    <div>We appreciate your patience.</div>
                    <div>Team {process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</div>
                   
                </section>
            </div>
        </div>
    )
}